"use client";
import React, { useState } from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

import defaultStyles from "../main.module.scss";

const RightSection = ({
  tab: { title, description, image, cta_link, cta_text },
  sliceStyles: styles = defaultStyles,
}) => (
  <div className={`${styles.tabsContentImgBlock} ${styles.versionImageBlock}`}>
    <div className={`${styles.versionImgHolder} ${styles.tabsContentImgHolder}`}>
      <PrismicImgix
        alt={image?.alt}
        src={image?.url}
        className={styles.tabsImageSize}
        desktop="600px"
      />
    </div>
    <div className={styles.versionBlockContent}>
      {checkContentPresence(title) && (
        <h2 className={`${styles.tabsImgTitle} ${styles.versionImgTitle}`}>
          {textResolver(title, { convertLabelToModular: true, convertToNormalText: true })}
        </h2>
      )}
      {checkContentPresence(description) && (
        <div className={`${styles.tabsBlockDescription} ${styles.versionImgDescription}`}>
          {textResolver(description, { convertLabelToModular: true })}
        </div>
      )}

      {cta_link?.url && (
        <div className={styles.versionTextCtaRow}>
          <PrismicLinkTag
            urlText={cta_text}
            url={cta_link?.url}
            target={cta_link?.target}
            className={styles.versionTextCta}
            convertLabelToModular
          />
        </div>
      )}
    </div>
  </div>
);

const ToggleableTabsVersionTwo = ({ doc, sliceStyles: styles = defaultStyles }) => {
  const [activeTab, setActiveTab] = useState(doc?.items[0]);

  const { title, link, link_text, bg_color } = doc?.primary || {};
  const sectionStyle = { backgroundColor: bg_color };

  return (
    <div
      className={`${styles.toggleableTabsSlice} ${styles.versionTabsSlice}`}
      style={sectionStyle}
    >
      <div className={`${styles.tabsSliceContainer} ${styles.versionSliceContainer}`}>
        <div className={`${styles.tabsSliceContentHolder} ${styles.versionContentHolder}`}>
          {checkContentPresence(title) && (
            <div className={styles.tabsSliceTitle}>
              {textResolver(title, { convertLabelToModular: true })}
            </div>
          )}
          <div className={`${styles.tabsContentSection} ${styles.versionContentSection}`}>
            <div className={`${styles.tabsContentLinks} ${styles.versionContentBlock}`}>
              {doc?.items?.map(
                (
                  {
                    icon_image,
                    heading,
                    description,
                    image,
                    title,
                    sub_heading,
                    cta_text,
                    cta_link,
                  },
                  idx,
                ) => {
                  const activeClass = title === activeTab?.title ? styles.active : "";
                  return (
                    <div
                      className={`${styles.tabsContentLinksRow} ${styles.versionLinksRow} ${activeClass}`}
                      key={`thumbnail-${idx}`}
                      onClick={() =>
                        setActiveTab({ title, description, image, cta_link, cta_text })
                      }
                    >
                      <div className={`${styles.tabLinksIconHolder} ${styles.versionIconHolder}`}>
                        {icon_image?.url && (
                          <PrismicImgix
                            alt={icon_image?.alt}
                            src={icon_image?.url}
                            className={styles.tabLinksIcon}
                            desktop="100px"
                          />
                        )}
                      </div>
                      {checkContentPresence(heading) && (
                        <div className={styles.solutionLinkBlock}>
                          <h3 className={styles.iconTitle}>
                            {textResolver(heading, { convertLabelToModular: true })}
                          </h3>
                          {checkContentPresence(sub_heading) && (
                            <div className={styles.iconDescription}>
                              {textResolver(sub_heading, { convertLabelToModular: true })}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                },
              )}
            </div>
            <RightSection tab={activeTab} />
          </div>
        </div>
        {link?.url && (
          <div className={styles.tabsSliceCtaRow}>
            <PrismicLinkTag
              urlText={link_text}
              url={link?.url}
              target={link?.target}
              className={styles.versionSliceFooterCta}
              convertLabelToModular
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ToggleableTabsVersionTwo;
